import { useEffect } from "react";
import { useSelector } from "react-redux";
import CardCarousel from "../../components/re-usable/card-carousel/card-carousel";
import CardCarouselExchange from "../../components/re-usable/card-carousel/card-carousel-exchange"
import {retrieveTopArticlesForHomePage} from "../../redux/slice/top-articles-for-home-page-slice"
import {retrieveHomeRegulatoryExchange} from "../../redux/slice/home-regulatory-exchange-slice"
import { RootState, useAppDispatch } from "../../redux/store";
//import { retrieveLatestDiscussion } from "../../redux/slice/external/latest-discussion-slice"
//import { ArticlesList } from "../../models/top-articles-for-home-page-model";

/*type latestDiscussionRequest = {
    articles: {
        title: string;
        isSubscribe: boolean;
        articlesLst: ArticlesList[][];
    }[]
}*/

const RegulatoryFocusAndExchange = () => {
    const { TopArticlesForHomePageData } = useSelector((state: RootState) => state.topArticlesForHomePage)
    const RegulatoryExchangeData = useSelector((state: RootState) => state.homeRegulatoryExchange.data);
    //const LatestDiscussionData = useSelector((state: RootState) => state.latestDiscussion.data);
    //const [isDiscussionLoaded, setIsDiscussionLoaded] = useState(false);

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(retrieveTopArticlesForHomePage())
        dispatch(retrieveHomeRegulatoryExchange())
    }, [dispatch])

    /*useEffect(() => {
        if (RegulatoryExchangeData.length > 0) {
            let data = RegulatoryExchangeData[0];
            let request: latestDiscussionRequest = {
                url: data.apiUrl,
                hliamKey: data.hliamKey,
                hlPassword: data.hlPassword
            }
            dispatch(retrieveLatestDiscussion(request))
        }
    }, [RegulatoryExchangeData]);*/

    const articlesList = TopArticlesForHomePageData.map((article) => {
        return article.articlesList;
    })

    const exchangeArticlesList = [RegulatoryExchangeData];

    return <div className="container sec-pad">
            <div className="col-md-12">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 landing-section-2">
                            <CardCarousel title="Regulatory Focus"  link="#"  articles={articlesList} includeSubscribe={true}/>
                        </div>
                        <div className="col-md-6 landing-section-2">
                            <CardCarouselExchange title="Regulatory Exchange" link="#" articles={exchangeArticlesList} includeSubscribe={false}/>
                        </div>
                    </div>
                </div>
            </div>
    </div>
}

export default RegulatoryFocusAndExchange;